import { services } from '@octadesk-tech/services'
import { getParameterHeaders } from '@/services/headers'
import { getBeaconURL } from '@/services/beacon-client'
import store from '@/store'

const getClient = () => {
  const headers = getParameterHeaders()
  return services.createClient('widgetBff', { headers })
}

export const sendMessage = (roomKey, payload) =>
  getClient()
    .then(client => client.post(`rooms/${roomKey}/messages`, payload))
    .then(response => response.data)

export const closeConversation = (roomKey, user) =>
  getClient()
    .then(client => client.put(`rooms/${roomKey}/close`, user))
    .then(response => response.data)

export const createChat = (payload = {}) =>
  getClient()
    .then(client =>
      client.post('rooms', {
        ...payload,
        clientTimeZone: new Date().getTimezoneOffset()
      })
    )
    .then(response => response.data)

export const updateChatCustomFields = (roomKey, customFields = []) => {
  if (!roomKey) {
    return Promise.resolve(null)
  }

  return getClient()
    .then(client => client.put(`rooms/${roomKey}/custom-fields`, customFields))
    .then(response => response.data)
}

export const updateChatOrganization = (roomKey, organization) => {
  if (!roomKey) {
    throw new Error('updateChatOrganization roomKey is required')
  }

  return getClient()
    .then(client => client.put(`rooms/${roomKey}/organization`, organization))
    .then(res => res.data)
}

export const startFluxBot = roomKey =>
  getClient()
    .then(client => client.post(`rooms/${roomKey}/bot/start`))
    .then(res => res.data)

export const readMessages = (roomKey, user) =>
  getClient()
    .then(client => client.put(`rooms/${roomKey}/messages/read`, user))
    .then(res => res.data)

export const receiveMessage = (roomKey, messageKey) =>
  getClient().then(client =>
    client.put(`rooms/${roomKey}/messages/${messageKey}/received`, undefined)
  )

export const verifyCancelCloseRoom = roomKey =>
  getClient().then(client =>
    client.get(`rooms/${roomKey}/cancel-schedule-room-close`)
  )

export const sendEventClose = (roomKey, message) => {
  const subdomain = getParameterHeaders().AppSubdomain
  const user = store.getters.user
  if (!user) return console.error('User is null', user)

  const payload = JSON.stringify({
    date: new Date().toISOString(),
    reason: `${message}`,
    typeReason: 'connectivity',
    user: {
      name: user.name ? user.name : '',
      email: user.email ? user.email : ''
    },
    subdomain
  })

  const url = getBeaconURL(roomKey)
  if (!url) return console.error('URL is null', url)

  navigator.sendBeacon(
    `${url}`,
    new Blob([payload], { type: 'application/json' })
  )
}
